import React from 'react';
import { FsSimpleTableProps } from 'ui-elements/tables/FsSimpleTable/FsSimpleTable';
import FsBody from 'ui-elements/typography/FsBody';

import DefaultLocales from 'globals/locales/default';
import { FinancialMarkersRowInstance } from 'models/report/financial-markers/financial-markers-row';
import {
  ValueBox,
  Value,
  PercentageValue,
  IncidentsLabel,
  IncidentsValue,
  IncidentsBox,
  NameBox,
} from './MarkersTable.style-elements';

const { incidents: incidentsLabel } = DefaultLocales;

export const getTableProps = (
  rows: FinancialMarkersRowInstance[]
): FsSimpleTableProps => ({
  rows: rows.map(({ id, name, incidents, percentage, value }) => ({
    id,
    name: (
      <NameBox>
        <FsBody>{name}</FsBody>
        <IncidentsBox>
          <IncidentsLabel>{incidentsLabel}:</IncidentsLabel>
          <IncidentsValue>{incidents}</IncidentsValue>
        </IncidentsBox>
      </NameBox>
    ),
    values: [
      <ValueBox>
        <PercentageValue>{`${percentage}%`}</PercentageValue>
        {incidents ? <Value>{value.displayValue()}</Value> : null}
      </ValueBox>,
    ],
  })),
});

export default {
  getTableProps,
};
